import { withLocalizationProvider } from '@features/localization';
import compose from 'ramda/src/compose';

import SaveAndPreviewBar from './save-and-preview-bar';

export default compose(withLocalizationProvider)(SaveAndPreviewBar);
